import React, {useState} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Button} from 'antd';

SecurityTextView.propTypes = {
    /**
     * 需要加密显示的文本
     */
    text: PropTypes.string,

    /**
     * 前面保留的字符数量
     */
    headerNum: PropTypes.number,

    /**
     * 尾部保留的字符数量
     */
    tailNum: PropTypes.number,

    /**
     * 替代原字符显示的安全字符，例如星号
     */
    securityChar: PropTypes.string,

    /**
     * 安全字符数量
     */
    securityCharNum: PropTypes.number,

    /**
     * 是否显示「隐藏/显示」按钮
     */
    showButton: PropTypes.bool,
};

function SecurityTextView({
    text,
    securityChar = '*',
    securityCharNum = 5,
    headerNum = 3,
    tailNum = 0,
    showButton = true,
}) {
    const [show, setShow] = useState(false);

    if (!text) return null;

    if (text.length <= headerNum + tailNum) {
        return text;
    }

    const secText =
        text.substring(0, headerNum) +
        _.repeat(securityChar, securityCharNum) +
        text.substring(text.length - tailNum);

    return (
        <>
            {show ? text : secText}
            {showButton && (
                <Button type="link" size="small" onClick={() => setShow(!show)}>
                    {show ? '隐藏' : '显示'}
                </Button>
            )}
        </>
    );
}

export default SecurityTextView;
